export const disableButtons = flag => {
    return {
        type: 'DISABLE_BUTTONS',
        flag
    }
};
